import Plyr from 'plyr'

/**
 * Find all video elements and enhance them with plyr.
 */
export function enhanceVideoPlayers(
  selector: string = 'video',
  additionalOptions: Plyr.Options = {}
) {
  document.querySelectorAll(selector).forEach(video => {
    enhanceVideo(video as HTMLVideoElement, additionalOptions)
  })
}

export function enhanceVideo(video: HTMLVideoElement, additionalOptions: Plyr.Options = {}) {
  new Plyr(video as HTMLVideoElement, {
    i18n: {
      speed: 'Geschwindigkeit',
    },
    ...additionalOptions,
  })

  video.setAttribute('preload', 'metadata')
}
